// extracted by mini-css-extract-plugin
export var btn = "L_mB z_tX z_tG d_bz d_bP d_bD d_dw";
export var full = "L_v7 d_w d_H";
export var hoverStyle = "L_mF";
export var zoom = "L_mG";